module.exports = __webpack_public_path__ + "img/botten-Y.3593465b.png";